import { useRef } from "react";
import { Upload, FileText, X } from "lucide-react";

/**
 * File attachment picker for the Request Quote form.
 * Controlled — files and remove handler come from the parent.
 */
export default function QuoteAttachments({ files, onAddFiles, onRemoveFile }) {
  const fileRef = useRef(null);

  return (
    <>
      <p className="text-[12px] text-brand-text-secondary/50 -mt-4 mb-4">
        Logos, photos, sketches, reference images &mdash; anything that helps us understand your project. Max 5 files, 5 MB each.
      </p>
      <div
        onClick={() => fileRef.current?.click()}
        className="border border-dashed border-brand-border hover:border-brand-gold/40 rounded-sm py-7 px-6 text-center cursor-pointer transition-colors duration-300 group"
        data-testid="quote-file-upload"
      >
        <Upload
          size={22}
          strokeWidth={1.6}
          className="mx-auto text-brand-text-secondary/40 group-hover:text-brand-gold transition-colors duration-300 mb-2"
        />
        <p className="text-[13px] text-brand-text-secondary/60">
          Click to browse or drag files here
        </p>
        <input
          ref={fileRef}
          type="file"
          multiple
          className="hidden"
          onChange={onAddFiles}
          accept="image/*,.pdf,.doc,.docx"
        />
      </div>
      {files.length > 0 && (
        <div className="mt-3 space-y-1.5">
          {files.map((f, i) => (
            <div
              key={`${f.name}-${f.size}`}
              className="flex items-center justify-between bg-brand-surface/60 px-4 py-2.5 rounded-sm border border-brand-border"
            >
              <div className="flex items-center gap-2 text-[13px] text-brand-text-secondary min-w-0">
                <FileText size={14} className="shrink-0 text-brand-gold/50" />
                <span className="truncate">{f.name}</span>
              </div>
              <button
                type="button"
                onClick={() => onRemoveFile(i)}
                className="text-brand-text-secondary/40 hover:text-red-400 transition-colors ml-3 shrink-0"
                data-testid={`remove-file-${i}`}
              >
                <X size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
